import React from "react";

import { Divider, Page, Flex, Typography } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

import kioskTransportIllustration from "@assets/images/kiosk-transport.svg";
import samskipLogo from "@assets/images/samskip-logo.png";

const Screensaver = () => {
  const { t } = useTranslation();
  return (
    <Page size="medium">
      <Flex alignItems="center" gap="medium" justifyContent="center" vertical>
        <img
          alt="SAMSKIP"
          className="w-1/4" // Makes the logo smaller and adds a margin below it
          src={samskipLogo}
        />
        <Divider />
        <img
          alt="CAR"
          className="max-w-full"
          src={kioskTransportIllustration}
        />
        <Typography>{t("TEXT_KIOSK_GREETING")}</Typography>
      </Flex>
    </Page>
  );
};

export default Screensaver;
